<ng-container *ngrxLet="vm$ as vm">
  <nty-page (refresh)="handleRefresh()">
    <ion-header nty-header>
      <nty-discussion-toolbar [currentUserId]="vm.currentUserId" />
    </ion-header>
    @if (vm.loading) {
      <nty-discussion-list-skeleton-loader />
    } @else if (!vm.hasFeatureAccess) {
      <nty-discussion-cm-tiered />
    } @else if (vm.discussions.length) {
      <nty-discussion-list [discussions]="vm.discussions" [isCompletedList]="vm.isShowingCompleted" />
      <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
        <ion-infinite-scroll-content />
      </ion-infinite-scroll>
    } @else {
      <nty-discussion-empty-state />
    }
  </nty-page>
</ng-container>
